/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScriptGroupList = {
  readonly uuid: string
  name: string
  /**
   * The script's programming language
   *
   * * `PY` - Python
   */
  language?: ScriptGroupList.language
  template: string | null
  language_version: string
  readonly created_at: string
  readonly created_by: string
  readonly is_draft: string
  readonly status: string
}
export namespace ScriptGroupList {
  /**
   * The script's programming language
   *
   * * `PY` - Python
   */
  export enum language {
    PY = "PY",
  }
}
